import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import { HtmlDoc } from '../html-doc';

export const addPinyinToHtml = ({ html, pinyinMap }, options = {}) => {
  const { createTextWithPinyinTag = createRubyTag } = options;

  const htmlDoc = HtmlDoc.fromPartialHtml(html);
  let currentTextNode = null;
  let textWithPinyinTagsToAdd = [];
  let pinyinTagToAdd = null;
  let currentSpan = null;
  let nonChineseText = '';

  function flushNonChineseText() {
    if (nonChineseText.length > 0) {
      textWithPinyinTagsToAdd.push(createTextWithPinyinTag(htmlDoc, { text: nonChineseText }));
    }

    nonChineseText = '';
  }

  function flushTextWithPinyinTags() {
    addTextWithPinyinTags(textWithPinyinTagsToAdd, currentTextNode);
    textWithPinyinTagsToAdd = [];
  }

  htmlDoc.eachChar((i, char, textNode) => {
    const pinyin = pinyinMap ? pinyinMap[i]?.pinyin ?? null : '';

    if (textNode !== currentTextNode) {
      flushNonChineseText();
      flushTextWithPinyinTags();
      currentTextNode = textNode;
    }

    if (pinyin === null && !isNumber(currentSpan)) {
      nonChineseText += char;
      return;
    }

    flushNonChineseText();

    if (!isNumber(currentSpan)) {
      currentSpan = pinyinMap?.[i]?.span ?? 1;
    }

    if (!pinyinTagToAdd) {
      pinyinTagToAdd = { offset: i, text: char, pinyin };
    } else {
      pinyinTagToAdd.text += char;
    }

    currentSpan -= 1;

    if (currentSpan <= 0) {
      textWithPinyinTagsToAdd.push(createTextWithPinyinTag(htmlDoc, pinyinTagToAdd));

      currentSpan = null;
      pinyinTagToAdd = null;
    }
  });

  flushNonChineseText();
  flushTextWithPinyinTags();

  return htmlDoc.toPartialString();
};

const createRubyTag = (htmlDoc, { offset, text, pinyin }) => {
  if (!isString(text)) {
    return htmlDoc.createElement('span', { text });
  }

  const rubyTag = htmlDoc.createElement('ruby', {
    attributes: { class: 'rubyText' },
  });

  const rbTag = htmlDoc.createElement('rb');
  rubyTag.append(rbTag);

  for (let i = 0; i < text.length; i++) {
    rbTag.append(
      htmlDoc.createElement('span', {
        attributes: {
          ...(!!pinyin && {
            class: 'withPinyin',
            'data-char-offset': `${offset + i}`,
            'data-char': text[i],
          }),
        },
        text: text[i],
      })
    );
  }

  if (pinyin) {
    const rtTag = htmlDoc.createElement('rt', {
      attributes: {
        class: 'withPinyin',
        'data-char-offset': `${offset}`,
        'data-char': text,
      },
      text: pinyin,
    });

    rubyTag.append(rtTag);
  }

  return rubyTag;
};

const addTextWithPinyinTags = (textWithPinyinTags = [], textNode = null) => {
  if (!textNode) {
    return;
  }

  textNode.replaceWith(...textWithPinyinTags);
};
